// extracted by mini-css-extract-plugin
module.exports = {"efCollectionPC":"VersionEU_efCollectionPC__cUfwf"};